import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
});

export const usePatientVitalNoteDeleteMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.delete(HTTP_ENDPOINTS.patientVitals.deleteVitalNote(req.id));
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientVitals.vitalNotes],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientVitals.all],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
};
